import { render } from "./NY2022WithoutSurveyHome.vue?vue&type=template&id=b26afb3c&scoped=true"
import script from "./NY2022WithoutSurveyHome.vue?vue&type=script&lang=js"
export * from "./NY2022WithoutSurveyHome.vue?vue&type=script&lang=js"

import "./NY2022WithoutSurveyHome.vue?vue&type=style&index=0&id=b26afb3c&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b26afb3c"],['__file',"src/views/pre/NY2022WithoutSurveyHome.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b26afb3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b26afb3c', __exports__)) {
    console.log('reload')
    api.reload('b26afb3c', __exports__)
  }
  
  module.hot.accept("./NY2022WithoutSurveyHome.vue?vue&type=template&id=b26afb3c&scoped=true", () => {
    console.log('re-render')
    api.rerender('b26afb3c', render)
  })

}


export default __exports__